export default __webpack_public_path__ + "static/media/artpoint.36bc5299.png";